<template>
  <div class='container'>
    <div v-if="notPageState">
      <no-message></no-message>
    </div>
    <div v-if="pageState" class="have_con">
      <div class="sign_title">签约信息</div>
      <div class="sign_container">
        <div class="sign_item" v-for="(item,index) in signData" :key="index">
          <div class="sign_info">
            <div class="car_number">
              <span>名称：</span>
              <span>{{item.name}}</span>
            </div>
            <div class="car_col">
              <span>卡类型：</span>
              <span>{{item.cardType == 1 ? '信用卡' : '借记卡'}}</span>
            </div>
            <div class="car_name">
              <span>卡号：</span>
              <span>{{item.account}}</span>
            </div>
            <div class="sign_state">
              <span>签约状态：</span>
              <span v-if="item.status == 1">在用</span>
              <span v-if="item.status == 2">解约</span>
              <span v-if="item.status == 3">签约中</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
  
</template>

<script>
import { axios } from "../../util/request";
import NoMessage from '../messageHint/noMessage';
export default {
  data() {
    return {
      userId: sessionStorage.getItem("USER-ID"),
      signData: [],
      // 页面状态
      pageState: false,
      notPageState: false,
    }
  },
  methods: {
    // 弹框内容
    showMessage(content){
      this.$createDialog({
          type: 'alert',
          title: '提示信息',
          content: content,
          icon: 'cubeic-alert'
      }).show()
    },
    // 获取用户信息
    getUserInfo(){
      if(this.userId) {
        axios.post('/User/Userinfo',{userId: this.userId}).then(res => {
          console.log(res);
          if(res.accountId){
            this.getSignData();
          } else {
            this.notPageState = true;
            // this.showMessage('请您实名后，查询签约信息');
          }
        })
      } else {
        this.$router.push({name: 'home'});
      }
    },
    // 获取签约信息
    getSignData() {
      axios.post("Account/SignChannelList", { userId: this.userId }).then(res => {
        console.log(res);
        if(res.state == 1) {
          this.pageState = true;
          this.signData = res.list;
        } else {
          this.notPageState = true;
        }
      })
    }
  },
  mounted() {
    this.getUserInfo();
    // this.getSignData();
  },
  components: {
    NoMessage
  },
}

</script>
<style scoped lang='less'>
@import '../../assets/styles/varibles.less';
.container {
  height: 100%;
  width: 100%;
  .have_con {
    padding-top: 2px;
    background-color: #fff;
  }
  .sign_title {
    height: 2.375rem;
    line-height: 2.375rem;
    width: 100%;
    // background-color: #efefef;
    // color: #383838;
    background-color: @titleColor;
    color: #fff;
    font-size: 0.875rem;
    text-align: left;
    font-weight: 500;
    text-indent: 1.125rem;
  }
  .sign_container {
    background: #fff;
    padding-top: 0.1rem;
    // box-sizing: border-box;
    .sign_item {
      margin-top: 0.625rem;
      .sign_info {
        height: 5.625rem;
        width: 20.8rem;
        background-color: #f18600;
        border-radius: 0.4rem;
        margin: 0 auto;
        text-align: left;
        color: #ffffff;
        .car_number {
          font-size: 1.06rem;
          padding-top: 1rem;
          padding-left: 0.81rem;
        }
        .car_col {
          padding-top: 0.5rem;
          font-size: 0.75rem;
          padding-left: 0.81rem;
        }
        .car_name {
          display: inline-block;
          width: 12rem;
          padding-top: 0.5rem;
          font-size: 0.75rem;
          padding-left: 0.81rem;
        }
        .sign_state {
          display: inline-block;
          font-size: 0.75rem;
        }
      }
    }
  }
}
</style>